import styled from 'styled-components';
import { Spacing8 } from 'autogen/design-tokens/tokens';
import type { ProductListVariantsModel } from 'autogen/swagger/all';
import ColorSwatch from 'components/product/Variants/Swatches/ColorSwatch';
import Variant from './Variant';

const Wrapper = styled.div`
    display: flex;
    gap: ${Spacing8};
    align-items: center;
    overflow: hidden;
    max-width: 100%;
`;

const StyledColorSwatch = styled(ColorSwatch)`
    flex-shrink: 0;
`;

export default function VariantName({ variants }: { variants: ProductListVariantsModel }) {
    if (variants.variantList.length === 0) return null;

    const { variantList } = variants;
    const { name, colors, isSelected, unavailable, linkAction } = variantList[0];

    return (
        <Wrapper>
            {!!colors.length && (
                <StyledColorSwatch
                    colors={colors}
                    unavailable={unavailable}
                    isSelected={isSelected}
                    name={name}
                    linkAction={linkAction}
                    size="sm"
                />
            )}
            <Variant size="S">{name}</Variant>
        </Wrapper>
    );
}
